import React, { Component } from "react";
import { Row, Col } from "antd";
import {
  GrantAgreementHeading,
  SectionMediumDividerPrint,
  Block,
} from "./styles";
import { ConfirmTerms } from "./Components/LanguageComponent";
import Step1SummaryPrint from "../RecommendGrant/Component/ViewEditSchedules/Components/Step1SummaryPrint";
import Step2SummaryPrint from "../RecommendGrant/Component/ViewEditSchedules/Components/Step2SummaryPrint";
import PermissionToPublish from "../RecommendGrant/Component/ViewEditSchedules/Components/PermissionToPublish";
import ViewRecurSchedule from "../RecommendGrant/Component/ViewEditSchedules/Components/ViewRecurSchedule";
import Step3SummaryPrint from "./Steps/EditAndReviewGrant/Step3SummaryPrint";
import InfoInline from "../RecommendGrant/Component/ViewEditSchedules/Components/InfoInline";
import PageAccountSummary from "../../../../CommonComponents/PageSummary/PageAccountSummary/PageAccountSummary";
import Heading from "../RecommendGrant/Component/ViewEditSchedules/Components/Heading";

export default class ConfirmationPagePrint extends Component {
  render() {
    return (
      <>
        <GrantAgreementHeading>
          {this.props.isGrantView
            ? `Agreement ID: ${this.props.grantAgreementId}`
            : `Grant Agreement Confirmation`}
        </GrantAgreementHeading>
        {this.props.isGrantView ? null : (
          <>
            <SectionMediumDividerPrint smallMarginTop smallMarginBottom />
            <ConfirmTerms />
            <SectionMediumDividerPrint smallMarginTop smallMarginBottom />
          </>
        )}
        {/* {this.props.isGrantView ? */}
        <PageAccountSummary
          key="accountName"
          label={this.props.accountName}
          value={this.props.accountNumber}
          dataName="accountName"
        />
        {/* : null } */}
        <Block flex fixEnds alignTop>
          <Block flex={2}>
            <Block>
              <Row type="flex" justify="space-between" align="center">
                <Col span={24} lg={12}>
                  {this.props.isGrantView ? (
                    <InfoInline
                      wordBreakOnly={true}
                      isPrint={true}
                      title="Entered Date: "
                      value={this.props.dateFormatter(
                        this.props.grantAgreementEnteredDate
                      )}
                    />
                  ) : (
                    <InfoInline
                      wordBreakOnly={true}
                      isPrint={true}
                      title="Grant Agreement ID:"
                      value={this.props.grantAgreementId}
                    />
                  )}
                </Col>
                <Col></Col>
              </Row>
            </Block>
            <Block>
              <Row type="flex" justify="space-between" align="center">
                <Col span={24} lg={12}>
                  {this.props.isGrantView ? (
                    <InfoInline
                      wordBreakOnly={true}
                      isPrint={true}
                      title="Status: "
                      value={this.props.status}
                    />
                  ) : (
                    <InfoInline
                      wordBreakOnly={true}
                      isPrint={true}
                      title="Entered Date:"
                      value={this.props.dateFormatter(
                        this.props.grantAgreementEnteredDate
                      )}
                    />
                  )}
                </Col>
                <Col></Col>
              </Row>
            </Block>
          </Block>
        </Block>
        <SectionMediumDividerPrint />
        <Step1SummaryPrint
          charityInfo={this.props.charityInfo}
          purposeRecognition={this.props.purposeRecognition}
          codeValueMappingData={this.props.codeValueMappingData}
        />
        <SectionMediumDividerPrint smallMarginTop smallMarginBottom />
        <PermissionToPublish publish={this.props.publishName} />
        <Block h={50} />
        <Step2SummaryPrint {...this.props.amountAllocation} />
        {this.props.scheduleType === "recurring" && (
          <>
            <SectionMediumDividerPrint smallMarginTop />
            <ViewRecurSchedule
              title="Recurring Grant Schedule"
              scheduleData={this.props.scheduleData}
            />
          </>
        )}
        <SectionMediumDividerPrint />
        <Heading
          title="Grant Agreement Payments"
          edit={false}
          className="grantAgreementPaymentTitle"
        />
        <Step3SummaryPrint payments={this.props.formattedPayments} />
      </>
    );
  }
}
